/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import {
  Modal,
  Button,
  FormGroup,
  Form,
  Col,
  FormControl,
  ControlLabel,
} from 'react-bootstrap';
import ControlTips from 'loracoms/ControlTips';
import FormBlock from 'loracoms/FormBlock';
import Select from 'loracoms/Select';
import Checkbox from 'loracoms/Checkbox';
import ShowIf from 'loracoms/ShowIf';
import enumsActions from 'loraactions/enums';
import IntlMsg from 'lorautils/intl/IntlMsg';
import ErrorSet from 'lorautils/errors/ErrorSet';
import { enumsToOptions } from 'lorautils/api/selector';
import callAPI from '@/api/callAPI';
import { isHexString } from 'lorautils/checkers/numbers';
import styles from './styles.scss';

const propTypes = {
  intl: PropTypes.object.isRequired,
  bandsOpts: PropTypes.array.isRequired,
  showModal: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  getBands: PropTypes.func.isRequired,
  appId: PropTypes.string.isRequired,
  onSuccess: PropTypes.func.isRequired,
};

const kInitialErrs = (
  ErrorSet
    .createEmpty()
    .add('FE_EMPTY', 'band')
    .add('FE_EMPTY', 'rx2dr')
    .add('FE_EMPTY', 'rx2freq')
    .add('FE_EMPTY', 'name')
    .add('FE_EMPTY', 'devaddr')
    .add('FE_EMPTY', 'appskey')
    .add('FE_EMPTY', 'nwkskey')
);

const kRX2DROptions = _.range(16).map(v => ({
  value: v,
  label: String(v),
}));

class AddAddress extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: props.showModal,
      name: '',
      bandsOpts: [],
      errors: kInitialErrs,
      submitted: false,
      isNew: true,
    };
    this.intlMsg = new IntlMsg(props.intl, 'applicationdetail.broadcast');
    this.handleChangeName = this.handleChangeName.bind(this);
  }

  componentWillMount() {
    this.props.getBands();
  }

  componentWillReceiveProps(nextProps) {
    const { showModal, bandsOpts } = nextProps;
    if (showModal !== this.props.showModal) {
      this.setState({ showModal });
    }
    this.setState({ bandsOpts });
  }

  checkKeys(key, val, errors = this.state.errors) {
    if (val.length === 0) {
      return errors.add('FE_EMPTY', key);
    } else if (!isHexString(val, { len: 32 })) {
      return errors.add(
        'FE_INVALIDAPPKEY',
        key,
        { message: this.intlMsg.errorMsg('FE_INVALIDAPPKEY') },
      );
    }
    return errors.remove(key);
  }

  checkRX2Freq(val, errors = this.state.errors) {
    if (!/^[0-9]+(\.[0-9]+)?$/.test(val)) {
      return errors.add(
        'FE_INVALIDNUM',
        'rx2freq',
        { message: this.intlMsg.errorMsg('FE_INVALIDNUM') },
      );
    }
    if (!/^[0-9]+(\.[0-9]{0,4})?$/.test(val)) {
      return errors.add(
        'FE_PREC4',
        'rx2freq',
        { message: this.intlMsg.errorMsg('FE_PREC4') },
      );
    }
    if (Number(val) < 100 || Number(val) > 16700) {
      return errors.add(
        'FE_OUTOFRANGE',
        'rx2freq',
        { message: this.intlMsg.errorMsg('FE_OUTOFRANGE') },
      );
    }
    return errors.remove('rx2freq');
  }

  handleOnHide() {
    this.props.onHide();
    this.setState({
      name: '',
      band: '',
      rx2dr: '',
      rx2freq: '',
      submitted: false,
      devaddr: '',
      appskey: '',
      nwkskey: '',
      isNew: true,
      errors: kInitialErrs,
    });
  }

  handleChangeName(e) {
    let { errors } = this.state;
    const name = _.trim(e.target.value);
    errors = name.length === 0 ? errors.add('FE_EMPTY', 'name') : errors.remove('name');
    this.setState({ errors, name });
  }

  handleChangeSelect(key, value) {
    const { errors } = this.state;
    this.setState({ [key]: value, errors: errors.remove(key) });
  }

  handleChangeFreq(e) {
    const rx2freq = _.trim(e.target.value);
    let { errors } = this.state;
    errors = this.checkRX2Freq(rx2freq, errors);
    this.setState({ rx2freq, errors });
  }

  handleChangeAddr(e) {
    const { errors } = this.state;
    let devaddr = _.trim(e.target.value);
    devaddr = devaddr.replace(/[:-]/g, '');
    if (devaddr.length !== 8 && devaddr.length !== 0) {
      this.setState({ errors: errors.add('FE_INVALIDADDR', 'devaddr') });
    } else if (devaddr.length === 0) {
      this.setState({ errors: errors.add('FE_EMPTY', 'devaddr') });
    } else {
      this.setState({ errors: errors.remove('devaddr') });
    }
    this.setState({ devaddr });
  }

  handleChangeKeys(key, e) {
    const val = _.trim(e.target.value);
    let { errors } = this.state;
    errors = this.checkKeys(key, val, errors);
    this.setState({ errors, [key]: val });
  }

  handleChangeType() {
    let { isNew } = this.state;
    isNew = !isNew;
    this.setState({ isNew });
  }

  handleOnConfirm() {
    const {
      isNew,
      name,
      band,
      rx2dr,
      rx2freq,
      devaddr = '',
      appskey = '',
      nwkskey = '',
     } = this.state;
    let { errors } = this.state;
    const { appId, onSuccess } = this.props;

    this.setState({ submitted: true });
    let param = { name, band, rx2dr, rx2freq: Number(rx2freq) * 10000 };
    if (!isNew) {
      param = Object.assign({}, param, { appskey, nwkskey, devaddr });
    } else {
      errors = errors.remove('devaddr').remove('appskey').remove('nwkskey');
    }

    if (!errors.isEmpty()) {
      return;
    }
    callAPI({
      endpoint: `/lora/apps/${appId}/broadcasts`,
      method: 'POST',
      body: { ...param },
    }).then((res) => {
      onSuccess({ ...res, isNew: true });
      this.handleOnHide();
    }).catch((err) => {
      this.setState({ errors: errors.add(err.code, 'submit') });
    });
  }

  render() {
    const {
      showModal,
      name = '',
      bandsOpts,
      errors,
      submitted,
      rx2freq = '',
      devaddr = '',
      isNew,
      appskey = '',
      nwkskey = '',
    } = this.state;
    return (
      <Modal
        show={showModal}
        onHide={() => this.handleOnHide()}
        bsClass="aisz-modal-light"
      >
        <Modal.Header closeButton >
          {this.intlMsg.msg('addressmodal.header')}
          {this.intlMsg.msg('addr.quato')}
        </Modal.Header>
        <Modal.Body>
          <Form horizontal>
            <FormGroup className="clearfix">
              <Col md={9} className="clearfix">
                <span className={`pull-right ${styles.marginLm}`}>
                  <Checkbox
                    id="inport-addr"
                    checked={!isNew}
                    onChange={() => this.handleChangeType()}
                  />
                  &nbsp;{this.intlMsg.msg('add.import')}
                </span>
                <span className={`pull-right ${styles.marginLm}`}>
                  <Checkbox
                    id="new-addr"
                    checked={isNew}
                    onChange={() => this.handleChangeType()}
                  />
                  &nbsp;{this.intlMsg.msg('add.new')}
                </span>
              </Col>
            </FormGroup>
            <FormGroup >
              <Col md={3}>
                <ControlLabel bsClass="aisz-control-label">
                  {this.intlMsg.msg('label.name')}&nbsp;*
                </ControlLabel>
              </Col>
              <Col md={6}>
                <FormControl
                  value={name}
                  bsClass="aisz-form-control-f"
                  placeholder={this.intlMsg.msg('add.placeholder')}
                  onChange={this.handleChangeName}
                />
                <ControlTips
                  show={errors.has('name') && submitted}
                  message={this.intlMsg.errorMsg(errors.get('name'))}
                  azStyle="danger"
                  placement="right"
                />
              </Col>
            </FormGroup>
            <ShowIf if={!isNew}>
              <div>
                <FormGroup >
                  <Col md={3}>
                    <ControlLabel bsClass="aisz-control-label">
                      {this.intlMsg.msg('send.addr')}&nbsp;*
                    </ControlLabel>
                  </Col>
                  <Col md={6}>
                    <FormControl
                      value={devaddr}
                      bsClass="aisz-form-control-f"
                      placeholder={this.intlMsg.msg('addr.placeholder')}
                      onChange={e => this.handleChangeAddr(e)}
                    />
                    <ControlTips
                      show={errors.has('devaddr') && submitted}
                      message={this.intlMsg.errorMsg(errors.get('devaddr'))}
                      azStyle="danger"
                      placement="right"
                    />
                  </Col>
                </FormGroup>
                <FormGroup >
                  <Col md={3}>
                    <ControlLabel bsClass="aisz-control-label">
                      {this.intlMsg.msg('addrlist.appskey')}&nbsp;*
                    </ControlLabel>
                  </Col>
                  <Col md={6}>
                    <FormControl
                      value={appskey}
                      bsClass="aisz-form-control-f"
                      onChange={e => this.handleChangeKeys('appskey', e)}
                    />
                    <ControlTips
                      show={errors.has('appskey') && submitted}
                      message={this.intlMsg.errorMsg(errors.get('appskey'))}
                      azStyle="danger"
                      placement="right"
                    />
                  </Col>
                </FormGroup>
                <FormGroup >
                  <Col md={3}>
                    <ControlLabel bsClass="aisz-control-label">
                      {this.intlMsg.msg('addrlist.nwkskey')}&nbsp;*
                    </ControlLabel>
                  </Col>
                  <Col md={6}>
                    <FormControl
                      value={nwkskey}
                      bsClass="aisz-form-control-f"
                      onChange={e => this.handleChangeKeys('nwkskey', e)}
                    />
                    <ControlTips
                      show={errors.has('nwkskey') && submitted}
                      message={this.intlMsg.errorMsg(errors.get('nwkskey'))}
                      azStyle="danger"
                      placement="right"
                    />
                  </Col>
                </FormGroup>
              </div>
            </ShowIf>
            <FormGroup >
              <Col md={3}>
                <ControlLabel bsClass="aisz-control-label">
                  {this.intlMsg.msg('addressmodal.band')}&nbsp;*
                </ControlLabel>
              </Col>
              <Col md={6}>
                <Select
                  options={bandsOpts}
                  onChange={band => this.handleChangeSelect('band', band)}
                />
                <ControlTips
                  show={errors.has('band') && submitted}
                  message={this.intlMsg.errorMsg(errors.get('band'))}
                  azStyle="danger"
                  placement="right"
                />
              </Col>
            </FormGroup>
            <FormGroup >
              <Col md={3}>
                <ControlLabel bsClass="aisz-control-label">
                  RX2DR&nbsp;*
                </ControlLabel>
              </Col>
              <Col md={6}>
                <Select
                  options={kRX2DROptions}
                  onChange={rx2dr => this.handleChangeSelect('rx2dr', rx2dr)}
                />
                <ControlTips
                  show={errors.has('rx2dr') && submitted}
                  message={this.intlMsg.errorMsg(errors.get('rx2dr'))}
                  azStyle="danger"
                  placement="right"
                />
              </Col>
            </FormGroup>
            <FormGroup >
              <Col md={3}>
                <ControlLabel bsClass="aisz-control-label">
                  RX2 Frequency&nbsp;*
                </ControlLabel>
              </Col>
              <Col md={6}>
                <FormControl
                  value={rx2freq}
                  bsClass="aisz-form-control-f"
                  onChange={e => this.handleChangeFreq(e)}
                />
                <ControlTips
                  show={errors.has('rx2freq') && submitted}
                  message={this.intlMsg.errorMsg(errors.get('rx2freq'))}
                  azStyle="danger"
                  placement="right"
                />
              </Col>
              <Col md={2} className={styles.unit}>MHz</Col>
            </FormGroup>
            <FormGroup >
              <Col md={6} mdOffset={3}>
                <Button
                  bsStyle="aisz-primary"
                  className={styles.fullWidth}
                  onClick={() => this.handleOnConfirm()}
                >
                  {this.intlMsg.msg('add.confirm')}
                </Button>
              </Col>
            </FormGroup>
            <FormGroup >
              <Col md={6} mdOffset={3}>
                <FormBlock
                  show={errors.has('submit')}
                  azStyle="danger"
                  message={this.intlMsg.errorMsg(errors.get('submit'))}
                />
              </Col>
            </FormGroup>
          </Form>
        </Modal.Body>
      </Modal>
    );
  }
}

AddAddress.propTypes = propTypes;

const mapStateToProps = state => ({
  bandsOpts: enumsToOptions('bands', state),
});

const mapDispatchToProps = {
  getBands: enumsActions.bands,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(AddAddress));




// WEBPACK FOOTER //
// ./src/containers/Application/coms/ApplicationDetail/coms/BroadcastView/coms/AddAddress/index.jsx